import { find, get } from 'lodash';
import { getOverviewImageSrc } from './helpers';

export const mapCheckoutProducts = (products: any[], allProducts: any[], currency: any) => {
  if (!products.length) return [];

  return products.map((product) => {
    const prod = find(allProducts, {
      _productGroup: product._productGroup,
      _id: product._product
    });
    const minQuantity = get(prod, 'minQuantity');

    return {
      ...product,
      displayImage: getOverviewImageSrc(get(prod, 'images', [])),
      title: get(prod, 'title', ''),
      options: get(prod, 'options', []),
      currency,
      slug: get(prod, 'slug', ''),
      maxImageSelection: get(prod, 'maxImageSelection', 0),
      canChangeShoppingCartQuantity: get(prod, 'canChangeShoppingCartQuantity', false),
      dimensions: get(prod, 'dimensions', { width: 0, height: 0, unit: '', depth: 0 }),
      minQuantity: minQuantity || null
    };
  });
};
